// src/pages/Gallery.jsx
export default function Gallery() {
  return (
    <div className="p-10 max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold mb-4">Gallery</h1>
      <p>Photos and videos of district events.</p>
    </div>
  );
}
